import React, { useState } from 'react';
import { Heading } from '@chakra-ui/react';

import { NumberTrack } from '../../../presentational/NumberTrack';

import { useStoreState } from 'pullstate';
import { CharacterStore } from '../../../../stores/characterStore';

export function HarmonyTrack({ value, max, onChange = () => {}, ...props }) {
  const [tempVal, setTempVal] = useState(null);

  const showHarmony = (tempVal || value) === 3;

  return (
    <NumberTrack
      value={tempVal || value}
      label="Harmony"
      onChange={val => {
        setTempVal(val);
        onChange(val);
      }}
      showHidden={showHarmony}
      hiddenMsg="Losing your Selves"
      {...props}
    >
      <Heading
        textStyle="heading"
        as="i"
        lineHeight={1.2}
        fontSize={{ base: 'xs', sm: 'sm', md: 'md' }}
      >
        Losing your Selves
      </Heading>
    </NumberTrack>
  );
}

export function EnsembleStats(props) {
  const harmony = useStoreState(CharacterStore, s => s?.stats?.harmony);
  if (harmony === null) {
    return null;
  }
  const max = 4;

  return (
    <HarmonyTrack
      value={harmony}
      max={max}
      onChange={val => {
        CharacterStore.update(s => {
          s.stats ?? (s.stats = {});
          s.stats.harony = val;
        });
      }}
      {...props}
    />
  );
}
